<template>
<div class="weather-statistical-wrapper">
  <dimension-weather-chart
    v-if="currentData && currentData.dimensions.length > 0"
    :key="currentData.id"
    :data-config="currentData"
    :dimension="dimension"
    :unit-prop="unitProp"
    :download-name="downloadName"
    chart-min-height="300px"
  />

  <div class="statistical-result">
    <div class="statistical-result-title">统计结果</div>
    <table>
      <thead>
      <tr>
        <th>参数</th>
        <th>最小值</th>
        <th>最大值</th>
        <th>平均值</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="(data, index) in statisticalData"
        :key="index"
      >
        <td>{{data.name}}</td>
        <td>{{data.min}}</td>
        <td>{{data.max}}</td>
        <td>{{data.avg}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import BaseSiteFactorData from '../../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import DataFormatter from '../../../../../model/DataFormatter'
import DimensionWeatherChart from '../../../../../components/Data/ChartWrapper/DimensionWeatherChart'

export default {
  name: 'WindStatistical',
  components: {DimensionWeatherChart},
  extends: BaseSiteFactorData,
  props: {
    data: {
      required: true,
      type: Array
    },
    pQuery: {
      required: true,
      type: Object
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, true, siteDeviceFactors => {
          return siteDeviceFactors.filter(siteDeviceFactor => /^101(0|1|2|3|4)|8000|8001$/.test(siteDeviceFactor.factorId))
        })
      ]
    },
    downloadName: () => '气象参数',
    currentData () {
      return this.dataList[0]
    },
    statisticalData () {
      const {currentData} = this

      if (!currentData) {
        return []
      }

      const {unitProp} = this
      const {seriesMap} = currentData
      return currentData.dimensions.filter(dimension => dimension.id !== '1013').map(dimension => {
        const values = Object.values(seriesMap[dimension.id]).reduce((list, data) => {
          const {value} = data

          if (Number.isFinite(value)) {
            list.push(value)
          }

          return list
        }, [])
        return {
          name: `${dimension.name}(${dimension[unitProp]})`,
          min: values.length === 0 ? '--' : Math.min(...values),
          max: values.length === 0 ? '--' : Math.max(...values),
          avg: values.length === 0 ? '--' : Number((values.reduce((sum, value) => sum + value, 0) / values.length).toFixed(2))
        }
      })
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]
      return {
        type: factorId === '1011' ? 'bar' : 'line',
        showSymbol: false
      }
    },
    setDataList (dataList) {
      const {pQuery, query} = this
      query.siteIds = pQuery.siteIds
      query.beginTime = pQuery.beginTime
      query.endTime = pQuery.endTime
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(query)))
      this.tmpList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
      this.formatData()
    },
    getData () {
      this.$api.NoData.getNoDataListBySite(this.pQuery).then(this.setNoDataList).catch(console.error).finally(() => {
        this.setDataList(this.data)
      })
    }
  },
  watch: {
    data (data) {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.weather-statistical-wrapper {
  display: grid;
  grid-template-columns: auto max-content;
  grid-column-gap: 1rem;
  align-items: flex-end;

  > * {
    min-width: 0;
  }

  .statistical-result {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    padding: {
      right: 1rem;
      bottom: 76px;
    }

    table {
      th,
      td {
        padding: 5px;
        border: 1px solid #EBEEF5;
      }

      th {
        background-color: #f9f9f9;
      }
    }
  }

  .statistical-result-title {
    font-weight: 700;
    text-align: center;
    border: 1px solid #EBEEF5 {
      bottom: 0;
    };
    line-height: 2;
    background-color: #f9f9f9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/02Wind-Rose/WindStatistical.vue